export class ToggleDisplay {
  static start() {
    const $elements = $('[data-toggle="display"]');

    if ($elements) {
      $elements.each(function init_toggle_displays() {
        const $element = $(this);

        $element.data('toggle_display', new ToggleDisplay($element));
      });
    }
  }

  constructor($element) {
    this.$element = $element;
    this.is_checkbox = this.$element.is('input[type="checkbox"]');
    this.is_reversed = this.is_checkbox && (this.$element.data('toggle-display-reverse') || false);

    const target = $element.data('toggle-display-target');

    if (target) {
      const toggle_parent = $element.data('toggle-display-parent');

      this.$target = $(target);

      if (this.$target && toggle_parent) {
        this.$target = this.$target.closest(toggle_parent);
      }

      if (this.$target) this.bind_events();
      if (this.is_checkbox) this.action_click();
    }
  }

  bind_events() {
    this.$element.on('click', () => this.action_click());
  }

  action_click() {
    if (this.is_checkbox) {
      if (this.is_reversed ? !this.$element.is(':checked') : this.$element.is(':checked')) {
        this.$target.removeClass('d-none');
      }
      else {
        this.$target.addClass('d-none');
      }
    }
    else {
      this.$target.toggleClass('d-none');
    }
  }
}
